import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const PaymentMethodFilterDropdown = ({
  onChange,
  options = [],
  isHaveAllOptions = true,
  isDefaultAll = true,
}) => {
  const { t } = useTranslation(["paymentMethod"]);
  const allOption = {
    label: "Tất cả",
    value: "all",
  };
  const [stateValue, setStateValue] = useState(
    isHaveAllOptions && isDefaultAll ? allOption : undefined
  );
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const optionList = isHaveAllOptions ? [allOption, ...options] : options;

  const onChangeMethod = options => {
    setStateValue(options);
    if (onChange && typeof onChange === "function") onChange(options);
  };

  return (
    <Dropdown
      isOpen={isOpenDropdown}
      toggle={() => setIsOpenDropdown(prev => !prev)}
    >
      <DropdownToggle className="btn primary-btn w-100" caret>
        {t("form.type")}
        {stateValue && <span>:&nbsp;{stateValue.label}</span>}
        <i className="mdi mdi-chevron-down" />
      </DropdownToggle>
      <DropdownMenu className="w-100">
        {optionList?.length > 0 &&
          optionList.map(options => (
            <DropdownItem
              key={`payment-method-${options.value}`}
              onClick={() => onChangeMethod(options)}
            >
              {options.label}
            </DropdownItem>
          ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default PaymentMethodFilterDropdown;
